import { useMemo } from "react";
import { useT } from "../i18n";
import { listTimezones } from "../lib/timezones";

export function TimezonePicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (tz: string) => void;
}) {
  const { t } = useT();
  const zones = useMemo(() => listTimezones(), []);

  return (
    <label className="tzfield">
      {t("timezoneLabel")}
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {!zones.some((z) => z.id === value) && <option value={value}>{value}</option>}
        {zones.map((z) => (
          <option key={z.id} value={z.id}>
            {z.label}
          </option>
        ))}
      </select>
      <span className="muted tzhint">{t("timezoneHint")}</span>
    </label>
  );
}
